<template>
  <div class="public-visa-check-container">
    <v-card class="login-card" v-if="!Object.keys(visa_detail).length">
      <v-card-text class="pa-0">
        <top-header-section text-item="Visa Check" :header-logo="logoUrl"/>
        <v-form lazy-validation ref="form" v-model="valid">
          <v-layout column wrap>
            <form-error-display-handler :errors="errors"/>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card class="login-card" v-if="Object.keys(visa_detail).length > 0">
      <v-card-text class="pa-0">
        <v-layout column wrap class="">
          <top-header-section text-item="Visa Information" :header-logo="logoUrl"/>
          <v-layout>
            <v-flex xs6>
              <list-item-detail
                  :show-tooltip="true"
                  :sub_title="visa_detail.name"
                  title="Full Name"/>
            </v-flex>
            <v-flex xs6>
              <list-item-detail
                  :show-tooltip="true"
                  :sub_title="visa_detail.passport_number"
                  title="Passport Number"/>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <list-item-detail
                  :sub_title="visa_detail.validity"
                  title="Passport Validity"/>
            </v-flex>
            <v-flex xs6>
              <list-item-detail
                  :show-tooltip="true"
                  :sub_title="visa_detail.type"
                  title="Visa Type"/>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <list-item-detail
                  :show-tooltip="true"
                  :sub_title="visa_detail.visa_number"
                  title="Visa Number"/>
            </v-flex>
          </v-layout>
          <v-flex xs12 v-if="visa_detail.start_date">
            <list-item-detail
                :show-tooltip="true"
                :sub_title="visa_detail.start_date+' to '+visa_detail.expiry_date"
                title="Visa Period"/>
          </v-flex>
          <v-flex xs12 v-if="visa_detail.issued_officer">
            <list-item-detail
                :show-tooltip="true"
                :sub_title="visa_detail.issued_officer"
                title="Issued By"/>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {validationMixin} from "../mixins/validationMixin";
import FormErrorDisplayHandler from "../components/FormErrorDisplayHandler";
import {NEPAL_SARKAR_LOGO, NEPALIPORT_LOGO_URL} from "../constant/appConstant";
import ListItemDetail from "../components/ListItemDetail"
import TopHeaderSection from "../components/TopHeaderSection";
import DatePickerNew from "../components/DatePickerNew"


export default {
  components: {
    FormErrorDisplayHandler, ListItemDetail, TopHeaderSection, DatePickerNew
  },
  mixins: [validationMixin],
  data() {
    return {
      nationalitySelected: '',
      valid: false,
      logoUrl: NEPALIPORT_LOGO_URL,
      sarkarLogo: NEPAL_SARKAR_LOGO,
      dob: "",
      passport_number: "",
      visa_number: "",
      errors: [],
      visa_detail: {},
      visaLoading: false,
    };
  },
  methods: {
    ...mapActions({
      searchForVisa: "VisaSingle/checkVisaInfo"
    }),
    checkVisa() {
      if (this.$route.query && this.$route.query.v) {
        let data = this.$route.query.v.split(',');
        if (data.length === 4) {
          this.visa_detail = {};
          this.errors = [];
          this.searchForVisa({
            dob: data[3],
            passport_number: data[2],
            country: data[0],
            visa_number: data[1],
          })
              .then((res) => {
                this.visa_detail = res.visa_detail;
              })
              .catch((err) => {
                this.errors.push(err.response.data.message);
              })
        } else {
          this.errors.push('No Visa Record Found.');
        }
      } else {
        this.errors.push('No Visa Record Found.');
      }
    },
  },
  async mounted() {
    this.checkVisa();
  }
}
;
</script>

<style scoped>
.login-card {
  border-radius: 4px;
  padding-left: 45px !important;
  padding-right: 45px !important;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>
